import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// scripts/prerender.mjs fills #root with static HTML for crawlers. createRoot
// replaces it on first render rather than hydrating, since the prerender
// can't know the visitor's theme or sign-in state.
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
